import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Spinner,
  Text,
  Select,
  HStack,
  Input,
} from '@chakra-ui/react';
import { tenantHeaders } from '../tenant';

const API_BASE = '/api/v1';

function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterAction, setFilterAction] = useState('');
  const [filterModel, setFilterModel] = useState('');

  const getAuthHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Token ${localStorage.getItem('token')}`,
    ...tenantHeaders(),
  });

  useEffect(() => {
    fetch(`${API_BASE}/audit-logs/`, { headers: getAuthHeaders() })
      .then(res => res.json())
      .then(data => {
        setLogs(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const getActionColor = (action) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'blue';
      case 'delete': return 'red';
      default: return 'gray';
    }
  };

  const filteredLogs = logs.filter(log => {
    if (filterAction && log.action !== filterAction) return false;
    if (filterModel && log.model_type !== filterModel) return false;
    return true;
  });

  if (loading) {
    return <Box textAlign="center" py={20}><Spinner size="xl" color="orange.500" /></Box>;
  }

  return (
    <Box>
      <Heading size="lg" mb={6}>Audit Log</Heading>

      <HStack mb={4} spacing={4}>
        <Select 
          placeholder="Filter by action" 
          value={filterAction} 
          onChange={(e) => setFilterAction(e.target.value)}
          maxW="200px"
        >
          <option value="create">Create</option>
          <option value="update">Update</option>
          <option value="delete">Delete</option>
        </Select>
        <Select 
          placeholder="Filter by model" 
          value={filterModel} 
          onChange={(e) => setFilterModel(e.target.value)}
          maxW="200px"
        >
          <option value="contact">Contact</option>
          <option value="api_key">API Key</option>
          <option value="configuration">Configuration</option>
          <option value="user">User</option>
        </Select>
      </HStack>

      <Box bg="white" p={6} borderRadius="lg" boxShadow="md" overflowX="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Time</Th>
              <Th>User</Th>
              <Th>Action</Th>
              <Th>Model</Th>
              <Th>Object</Th>
              <Th>IP Address</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredLogs.map(log => (
              <Tr key={log.id}>
                <Td fontSize="sm">{new Date(log.created_at).toLocaleString()}</Td>
                <Td>{log.username || '-'}</Td>
                <Td>
                  <Badge colorScheme={getActionColor(log.action)}>
                    {log.action}
                  </Badge>
                </Td>
                <Td><Badge variant="outline">{log.model_type}</Badge></Td>
                <Td>{log.object_name || log.object_id || '-'}</Td>
                <Td><Text fontSize="sm" fontFamily="mono">{log.ip_address || '-'}</Text></Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        {filteredLogs.length === 0 && (
          <Text color="gray.500" textAlign="center" py={8}>No audit logs found</Text>
        )}
      </Box>
    </Box>
  );
}

export default AuditLog;
